module.exports = __webpack_public_path__ + "static/artworking-mobile-c517520bb98b68d42b6d9e6563fd2463.jpg";